module.exports = __webpack_public_path__ + "img/basketball-dark.1611e394.svg";